<template>
  <div class="all_box">
    <div class="tabselecr_box">
      <div style="display: flex; flex-wrap: wrap; gap: 10px;">
        <el-input v-model.trim="query.keywords" clearable style="width:240px" placeholder="请输入员工名称/外部客户ID" />
        <el-input v-model.trim="query.employee_no" clearable style="width:200px" placeholder="请输入员工编号" />
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="添加开始时间"
          end-placeholder="添加结束时间"
          value-format="yyyy-MM-dd"
          style="width:300px"
        />
        <el-select
          v-model="query.corp_id"
          filterable
          clearable
          :loading="corpLoading"
          placeholder="请选择企业"
          style="width:240px"
        >
          <el-option
            v-for="item in corpList"
            :key="item.id"
            :label="item.corp_name"
            :value="item.corp_id"
          />
        </el-select>
        <el-select
          v-model="query.relation_user"
          placeholder="是否关联"
          style="width:160px"
        >
          <el-option label="全部" :value="0" />
          <el-option label="关联用户" :value="1" />
          <el-option label="未关联用户" :value="2" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <el-button v-if="showButton" type="success" icon="el-icon-s-data" @click="calculate">统计</el-button>
        <el-button type="primary" icon="el-icon-upload" :loading="importLoading" @click="importclick">导入阅文企业微信客户</el-button>
        <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls"
          style="display: none"
          @change="handleFileChange"
        >
      </div>
    </div>

    <el-table ref="multipleTable" v-loading="loading" :data="tableData" border max-height="700">
      <el-table-column prop="id" label="id" align="center" width="60px" />
      <el-table-column prop="employee_no" label="员工编号" align="center" width="250px" />
      <el-table-column prop="name" label="员工名字" align="center" width="100" />
      <el-table-column prop="user_id" label="企业成员userid" align="center" width="250px" />
      <el-table-column prop="external_user_id" label="外部联系人userid" align="center" width="300" />
      <el-table-column prop="remark" label="备注" align="center" />
      <el-table-column prop="createtime_text" label="添加好友时间" align="center" />
      <el-table-column prop="add_way" label="客户的来源" align="center">
        <template slot-scope="scope">
          {{ fifter(scope.row.add_way) }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at_text" label="创建时间" align="center" />
      <el-table-column label="是否付费" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.paying_user">是 ￥{{ scope.row.charge_amount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述" align="center" />
    </el-table>

    <el-dialog title="统计" :visible.sync="dialogVisible" :append-to-body="true" :destroy-on-close="true" :close-on-click-modal="false" width="800px" @close="closeEvent">
      <EnterCalculate ref="enterCalculate" :newkeywords="newkeywords" />
    </el-dialog>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import EnterCalculate from './components/enter.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { contactFollowUsers, yueWenUserImport } from '@/api/officialaccount.js'
import { filterCorplist } from '@/api/enterprisewechatControl.js'
import { getQcConfig } from '@/api/sourceminiprogram.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'

export default {
  name: 'EmployeeCorrespondencer',
  components: { PaginationRight, EnterCalculate },
  data() {
    return {
      dateRange: [],
      corpList: [],
      corpLoading: false,
      newkeywords: [],
      query: {
        page: 1,
        pageSize: 10,
        keywords: null,
        employee_no: null,
        corp_id: null,
        createtime_begin: null,
        createtime_end: null,
        relation_user: 0
      },
      showButton: false,
      dialogVisible: false,
      total: null,
      tableData: [],
      loading: false,
      importLoading: false,
      config: null,
      arr: [
        { id: 0, name: '未知来源' },
        { id: 1, name: '扫描二维码' },
        { id: 2, name: '搜索手机号' },
        { id: 3, name: '名片分享' },
        { id: 4, name: '群聊' },
        { id: 5, name: '手机通讯录' },
        { id: 6, name: '微信联系人' },
        { id: 8, name: '安装第三方应用时自动添加的客服人员' },
        { id: 9, name: '搜索邮箱' },
        { id: 10, name: '视频号添加' },
        { id: 11, name: '通过日程参与人添加' },
        { id: 12, name: '通过会议参与人添加' },
        { id: 13, name: '添加微信好友对应的企业微信' },
        { id: 14, name: '通过智慧硬件专属客服添加' },
        { id: 15, name: '通过上门服务客服添加' },
        { id: 16, name: '通过获客链接添加' },
        { id: 201, name: '内部成员共享' },
        { id: 202, name: '管理员/负责人分配' }
      ]
    }
  },
  watch: {
    dateRange(val) {
      this.query.createtime_begin = val?.[0] || null
      this.query.createtime_end = val?.[1] || null
    }
  },
  mounted() {
    this.initCorps()
  },
  methods: {
    closeEvent() {
      this.$refs.enterCalculate.closeEventadd()
    },
    calculate() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.enterCalculate.theUpdata()
      })
    },
    async initCorps() {
      this.corpLoading = true
      try {
        const res = await filterCorplist({})
        if (res.code === 200) {
          this.corpList = res.data || []
        }
      } finally {
        this.corpLoading = false
      }
    },
    async list() {
      this.loading = true
      try {
        const data = await contactFollowUsers(this.query)
        this.tableData = data.data.list
        this.total = data.data.total
      } finally {
        this.loading = false
      }
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    async searchclick() {
      this.query.page = 1
      await this.list()
      if (this.tableData.length > 0) {
        this.showButton = true
        this.newkeywords = this.tableData
      } else {
        this.showButton = false
      }
    },
    rechargeclick() {
      this.query = {
        page: 1,
        pageSize: 10,
        keywords: null,
        employee_no: null,
        corp_id: null,
        createtime_begin: null,
        createtime_end: null,
        relation_user: 0
      }
      this.dateRange = []
      this.list()
    },
    fifter(id) {
      const index = this.arr.findIndex(item => item.id === id)
      return index === -1 ? '' : this.arr[index].name
    },
    importclick() {
      this.$refs.fileInput.click()
    },
    async getconfig() {
      const res = await getQcConfig({ new: 1 })
      this.config = res.data
    },
    async handleFileChange(e) {
      const file = e.target.files[0]
      this.$refs.fileInput.value = ''
      if (!file) return
      if (!/\.(xlsx|xls)$/i.test(file.name)) {
        this.$message.warning('只能上传 Excel 文件（.xlsx/.xls')
        return
      }
      this.importLoading = true
      try {
        if (!this.config) {
          await this.getconfig()
        }
        const res = await uploadFilesimg(
          file,
          () => {},
          'yuewen',
          this.config
        )
        console.log('uploadFilesimg', res)
        const excelUrl = res.files[0].data.Location
        await yueWenUserImport({ excel_url: excelUrl })
        this.$message.success('导入成功')
        // this.list()
      } catch (err) {
        this.$message.error('导入失败')
      } finally {
        this.importLoading = false
      }
    }
  }
}
</script>

<style scoped>
.all_box {
  padding: 30px;
}
.tabselecr_box {
  margin-bottom: 15px;
}
</style>
